module.exports = __webpack_public_path__ + "console/img/logo.4201e903.png";